// PR 58 / 59 fixes · agent B — screen texts, EN + AR (merged into lib/i18n.js translations; big-file rule).
//   F2  "First-year engagement - no comparatives" on Engagement settings (components/FirstYearToggle.jsx) and the coded
//       refusals of PUT /engagements/{id}/first-year (toErrMsg reads errors.<CODE> for a non-English screen).
//       The Validation screen's N/A status (grey) and its label already exist (lib/i18n/1200_restatement.js); the check detail
//       "N/A - first-year engagement" comes from the server in EN + AR.
export const I18N_FX_B = {
  en: {
    fxB: {
      firstYear: {
        label: "First-year engagement - no comparatives",
        help: "Tick when the entity has no prior period: the two prior-year validation checks then read \"N/A - first-year "
          + "engagement\" and do not block the publication PDF, and a head with no balance follows the normal \"not required\" "
          + "rule. It cannot be ticked while prior-year data (general ledger, trial balance or opening balances) is loaded.",
        on: "Yes",
        off: "No",
        rolesOnly: "Only a Partner or a Manager can change this setting.",
        saved: "First-year setting saved",
        saveFailed: "Could not save the first-year setting",
      },
    },
    errors: {
      FIRST_YEAR_HAS_PRIOR_DATA: "This engagement has prior-year data, so it cannot be marked \"First-year engagement - no comparatives\".",
      FIRST_YEAR_ROLE: "Only a Partner or a Manager can change \"First-year engagement - no comparatives\".",
    },
  },
  ar: {
    fxB: {
      firstYear: {
        label: "ارتباط السنة الأولى - بدون أرقام مقارنة",
        help: "حدّد هذا الخيار عندما لا تكون للمنشأة فترة سابقة: يظهر فحصا التحقق الخاصان بالسنة السابقة \"لا ينطبق - ارتباط السنة "
          + "الأولى\" ولا يمنعان إصدار ملف القوائم المالية، ويتبع البند الذي لا رصيد له قاعدة \"غير مطلوب\" المعتادة. لا يمكن تحديده "
          + "ما دامت بيانات السنة السابقة (دفتر الأستاذ أو ميزان المراجعة أو الأرصدة الافتتاحية) محمّلة.",
        on: "نعم",
        off: "لا",
        rolesOnly: "لا يغيّر هذا الإعداد إلا الشريك أو المدير.",
        saved: "تم حفظ إعداد السنة الأولى",
        saveFailed: "تعذّر حفظ إعداد السنة الأولى",
      },
    },
    errors: {
      FIRST_YEAR_HAS_PRIOR_DATA: "لهذا الارتباط بيانات للسنة السابقة، لذا لا يمكن تحديده \"ارتباط السنة الأولى - بدون أرقام مقارنة\".",
      FIRST_YEAR_ROLE: "لا يغيّر \"ارتباط السنة الأولى - بدون أرقام مقارنة\" إلا الشريك أو المدير.",
    },
  },
};

export default I18N_FX_B;
